<template>
<div>
{{ dateFormat }}
</div>
</template>

<script>
  import moment from 'moment'
    export default {
        name: 'CellRendererDate',
        computed: {
          dateFormat() {
            moment.locale('de');
            return moment(String(this.params.value)).format('LLL')
          }
        }
    }
</script>